'use strict';

/*global app*/
/*global services*/
/*global isEmpty*/
/*global compareDates*/
/*global diffDate*/
/*global initialize*/
/*global replaceAttrKey*/
function OrderConfirm(containerID) {
  this.containerID = containerID;
  this.$container = null;
  this.$form = null;
  this.confirmedSubmit = false;

  this.init();
}

OrderConfirm.prototype = $.extend({}, {
  constructor: 'OrderConfirm',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '#' + _this.containerID + ' .change-item', function () {
      _this.changeItem($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .order-items__date', function () {
      _this.changeDate($(this).closest('.order-items__fill-date-wrapper'));
      return false;
    });

    $('body').on('click', '#' + _this.containerID + ' .fill-date', function () {
      _this.fillDate($(this).closest('.order-items__fill-date-wrapper'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .item__supplier-delivery-date', function () {
      _this.changeDeliveryDate($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('change', '#' + _this.containerID + ' .item__not-delivered', function () {
      _this.itemNotDelivered($(this).closest('.order-items__item'));
      return false;
    });

    $('body').on('submit', '#' + _this.containerID + ' form', function () {
      return _this.isAllowedSubmitForm();
    });
  },

  //----------------------------------------------------------------------------

  validateDate: function validateDate(date) {
    var now = new Date();

    if (compareDates(now, date) < 0) {
      app.viewErrorMessage(app.t('date_in_past'));
      return false;
    }

    if (diffDate(new Date(), date) > app.param('max_date_warning')) {
      app.viewErrorMessage(app.t('date_in_future'));
      return false;
    }

    return true;
  },

  isValid: function isValid() {
    var _this = this;

    var ret = true;
    _this.$form.find('.order-items__item:not(.order-items__item--processed)').each(function () {
      var $row = $(this);

      var $notDelivered = $row.find('.item__not-delivered');
      var $date = $row.find('.item__supplier-delivery-date');

      if (isEmpty($date.val()) && !$notDelivered.is(':checked')) {
        ret = false;
      }
    });

    return ret;
  },

  isAllowedSubmitForm: function isAllowedSubmitForm() {
    var _this = this;

    if (!_this.confirmedSubmit && !_this.isValid()) {
      services.get('confirm-service').confirmHtml(services.get('translator').trans('order_issued.invalid_form'), function (ret) {
        if (ret) {
          _this.confirmedSubmit = true;
          _this.$form.submit();
        }
      });

      return false;
    }

    return true;
  },

  getChangeItemForm: function getChangeItemForm(origQuantity, $row) {
    var _this = this;
    var $form = _this.$container.find('.change-item-form-wrapper').clone();

    $form.removeClass('hidden');
    $form.find('input[name="Quantity"]').val(origQuantity);
    $form.find('.unit').text($row.find('.unit').text());

    return $form;
  },

  changeItem: function changeItem($row) {
    var _this = this;

    var modal = services.get('modal');
    var translator = services.get('translator');

    var origQuantity = parseFloat($row.find('input[name^="Quantity"]').val());

    modal.empty().open({
      height: '150',
      width: 'sm',
      title: translator.trans('order_issued.item.change_amount'),
      form: true,
      openCallBack: function () {
        modal.contentDOM().find('input:first').focus();
      },

      submitCallBack: function () {
        var $content = modal.contentDOM();
        $content.find('has-error').removeClass('has-error');

        var $input = $content.find('input[name="Quantity"]');
        var quantity = parseFloat($input.val().replace(',', '.'));

        if (!isEmpty(quantity)) {
          if (origQuantity >= quantity && quantity > 0) {
            $row.find('input[name^="Quantity"]').val(quantity);
            $row.find('.quantity').text(quantity);

            var newQuantity = origQuantity - quantity;
            if (newQuantity > 0) {
              var $dataContainer = _this.$container.find('.data-container');

              var $newRow = $row.clone();
              var newKey = parseInt($dataContainer.data('last_key')) + 1;
              $dataContainer.data('last_key', newKey);

              $newRow.find('input[name^="Quantity"]').val(newQuantity);
              $newRow.find('.quantity').text(newQuantity);
              $newRow.find('.item__supplier-delivery-date').removeAttr('disabled');
              $newRow.find('.item__not-delivered').prop('checked', false);
              $newRow.find('.clear-input').val('');
              $newRow.find('input').each(function () {
                replaceAttrKey($(this), 'name', 1, newKey);
              });

              $newRow.insertAfter($row);

              initialize($newRow);
            }

            modal.close();
          } else {
            $input.parent().addClass('has-error');
          }
        } else {
          $input.parent().addClass('has-error');
        }
      }
    }).content(_this.getChangeItemForm(origQuantity, $row));
  },

  changeDate: function ($row) {
    var _this = this;

    var $input = $row.find('.order-items__date');
    var $wrapper = $input.parent();

    $wrapper.removeClass('has-error');
    var date = $input.val();

    if (isEmpty(date)) {
      return _this;
    }

    if (!_this.validateDate(date)) {
      $wrapper.addClass('has-error');
    }
  },

  fillDate: function fillDate($row) {
    var _this = this;

    var date = $row.find('.order-items__date').val();
    if (isEmpty(date)) {
      return _this;
    }

    _this.$container.find('.item__supplier-delivery-date').each(function () {
      var $input = $(this);

      if (!$input.is(':disabled') && isEmpty($input.val())) {
        $input.val(date);
      }
    });
  },

  changeDeliveryDate: function ($row) {
    var _this = this;

    var $notDelivered = $row.find('.item__not-delivered');

    var $input = $row.find('.item__supplier-delivery-date');
    var $wrapper = $input.parent();
    var date = $input.val();

    if (!isEmpty(date)) {
      $notDelivered.prop('checked', false);
    }

    if (!_this.validateDate(date)) {
      $wrapper.addClass('has-error');
    } else {
      $wrapper.removeClass('has-error');
    }
  },

  itemNotDelivered: function itemNotDelivered($row) {
    var $notDelivered = $row.find('.item__not-delivered');

    var $input = $row.find('.item__supplier-delivery-date');
    var $wrapper = $input.parent();

    if ($notDelivered.is(':checked')) {
      $input.val('');
      $input.attr('disabled', true);
      $wrapper.removeClass('has-error');
    } else {
      $input.removeAttr('disabled');
    }
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('#' + _this.containerID);
    _this.$form = _this.$container.find('form');
    _this.registerCallbacks();
  }
});
